module.exports = __webpack_public_path__ + "img/bow-zagreus.34c1e0e2.jpg";